import React, { forwardRef } from 'react';

import { clsx } from 'clsx';

import FadeIn from 'src/components/elements/FadeIn';

import { PRIVACY_POLICY_LINK } from '../../constants';
import { ContactFormFeature } from './ContactForm';

import styles from './FormBlock.scss';

const FormBlock = forwardRef<HTMLDivElement, React.ComponentPropsWithRef<'div'>>((props, ref) => {
  return (
    <section ref={ref} {...props}>
      <FadeIn
        delay={0.2}
        className={clsx(styles.gradientBackground, styles.formBlockContainer)}
        id="form"
      >
        <p className={styles.title}>
          <span className={clsx(styles.title, styles.titleThin)}>Ready to unlock</span> neo travel
          loyalty?
        </p>
        <p className={styles.subTitle}>
          Please leave your details and we’ll get in touch with you shortly
        </p>
        <ContactFormFeature />
        <p className={styles.privacyText}>
          By clicking “Submit”, you agree to the{' '}
          <a className={styles.privacyLink} target="_blank" href={PRIVACY_POLICY_LINK}>
            Privacy Policy
          </a>
        </p>
      </FadeIn>
    </section>
  );
});

export default FormBlock;
